// import COLORS from '../core/colors.json';
import PRIMARY_COLOR from './primary-color.json';
import { components as coreComponents } from '../core/components';
import { hexToRgbChannel, createPaletteChannel } from '../styles';
// import { grey as coreGreyPalette, primary as corePrimaryPalette } from '../core/palette';
// import { createShadowColor, customShadows as coreCustomShadows } from '../core/custom-shadows';

// ----------------------------------------------------------------------

/**
 * [1] settings @primaryColor
 * [2] settings @contrast
 */

export function updateCoreWithSettings(theme, themeModule, settings) {
  const { colorSchemes, customShadows } = theme;

  return {
    ...theme,
    colorSchemes: {
      ...colorSchemes,
      light: {
        palette: {
          ...colorSchemes?.light?.palette,
          /** [1] */
          primary: getPalettePrimary(settings.primaryColor, themeModule.COLORS.primary),
          /** [2] */
          background: {
            ...colorSchemes?.light?.palette?.background,
            default: getBackgroundDefault(settings.contrast, themeModule.grey),
            defaultChannel: hexToRgbChannel(getBackgroundDefault(settings.contrast, themeModule.grey)),
          },
        },
      },
      dark: {
        palette: {
          ...colorSchemes?.dark?.palette,
          /** [1] */
          primary: getPalettePrimary(settings.primaryColor, themeModule.COLORS.primary),
        },
      },
    },
    customShadows: {
      ...customShadows,
      /** [1] */
      primary:
        settings.primaryColor === 'default'
          ? themeModule.customShadows('light').primary
          : themeModule.createShadowColor(getPalettePrimary(settings.primaryColor, themeModule.COLORS.primary).mainChannel),
    },
  };
}

// ----------------------------------------------------------------------

export function updateComponentsWithSettings(settings) {
  const components = {};

  /** [2] */
  if (settings.contrast === 'hight') {
    const MuiCard = {
      styleOverrides: {
        root: ({ theme, ownerState }) => {
          let rootStyles = {};
          if (typeof coreComponents?.MuiCard?.styleOverrides?.root === 'function') {
            rootStyles =
              coreComponents.MuiCard.styleOverrides.root({
                ownerState,
                theme,
              }) ?? {};
          }

          return {
            ...rootStyles,
            boxShadow: theme.customShadows.z1,
          };
        },
      },
    };

    components.MuiCard = MuiCard;
  }

  return { components };
}

// ----------------------------------------------------------------------

function getPalettePrimary(primaryColorName, primaryColor) {
  /** [1] */

  const PRIMARY_COLORS = {
    default: primaryColor,
    cyan: PRIMARY_COLOR.cyan,
    purple: PRIMARY_COLOR.purple,
    blue: PRIMARY_COLOR.blue,
    orange: PRIMARY_COLOR.orange,
    red: PRIMARY_COLOR.red,
  };
  const selectedPrimaryColor = PRIMARY_COLORS[primaryColorName];
  const updatedPrimaryPalette = createPaletteChannel(selectedPrimaryColor);

  return primaryColorName === 'default' ? primaryColor : updatedPrimaryPalette;
}

function getBackgroundDefault(contrast, grey) {
  /** [2] */
  return contrast === 'default' ? '#FFFFFF' : grey[200];
}
